export interface IGetProductComboRequest {
  skus: string[];
  terminalId: number;
  language?: string;
}

export interface IComboGift {
  quantity?: number;
  sku?: string;
  imageUrl?: string;
  sellPrice?: number;
  name?: string;
}

export interface IPromotionBenefit {
  discount?: {
    flat?: number;
    maxAmount?: number;
    maxAmountPerOrder?: number;
    percent?: number;
  };
  gifts?: IComboGift[];
  voucher?: { quantity: number; name: string };
}

export interface IComboPromotion {
  applyOn?: string;
  benefit?: IPromotionBenefit;
  condition?: { exclusions?: IComboPromtionExclusions[] };
  id: number;
}

export interface IComboPromtionExclusions {
  applyOn?: string[];
  isDefault?: boolean[];
  paymentMethods?: string[];
}

export interface IProductPrice {
  latestPrice: number;
  supplierRetailPrice: number;
}

export interface IConditionProduct {
  sku: string;
  name: string;
  imageUrl: string;
  price: IProductPrice;
  bestPromotionIds?: number[];
}

export interface IComboCondition {
  requiredQuantity: number;
  products: IConditionProduct[];
  selectorType?: ESelectorType;
  categoryIds?: number[];
  brandIds?: number[];
}

export enum ESelectorType {
  SKU = 'SKU',
  CATEGORY = 'CATEGORY',
  BRAND = 'BRAND',
}

export interface ICombo {
  totalProduct: number;
  promotion: IComboPromotion;
  conditions: IComboCondition[];
}

export interface IComboProduct {
  sku: string;
  name: string;
  price: IProductPrice;
  imageUrl: string;
  requiredQuantity: number;
  combos: ICombo[];
  bestComboDiscount: number;
}

export interface IGetProductComboResponse {
  code: number;
  traceId: string;
  message: string;
  result: {
    products: IComboProduct[];
  };
}

// Interfaces are used on FE
export interface IComboConditionWithKey extends IComboCondition {
  key: number;
}

export interface IComboWithKey extends Omit<ICombo, 'conditions'> {
  key: number;
  conditions: IComboConditionWithKey[];
}

export interface IActiveCombo extends Omit<IComboWithKey, 'conditions'> {
  conditions: Array<{
    key: number;
    requiredQuantity: number;
    product: IConditionProduct;
  }>;
  discountByCombo: number;
  totalDiscount: number;
  totalAmount: number;
}

export interface IComboGroup {
  // "key" is totalProduct in combos
  [key: number]: {
    combos: Array<IActiveCombo>;
  };
}

export interface ISelectingProduct {
  totalProductInCombo: number;
  comboKey: number;
  conditionKey: number;
  product: IConditionProduct;
}

export interface IDisplayProduct extends IConditionProduct {
  requiredQuantity: number;
}

export enum ProductComboScreen {
  cart = 'cart',
  product_detail = 'product-detail',
}
